import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_ACTIVE_TAB, HOTEL_DETAILS_MODAL } from "@website/accommodation-ui/constant/keys";
import { useTourCardCarousel } from "@website/accommodation-ui/tour-card/tour-card-carousel/hooks";
import { TourCardCarouselBadges } from "@website/accommodation-ui/tour-card/tour-card-carousel/tour-card-carousel-badges";
import { TourCardCarouselNavigation } from "@website/accommodation-ui/tour-card/tour-card-carousel/tour-card-carousel-navigation";
import { TourCardCarouselPagination } from "@website/accommodation-ui/tour-card/tour-card-carousel/tour-card-carousel-pagination";
import { TourCardCarouselPropertiesType } from "@website/accommodation-ui/tour-card/tour-card-carousel/types";
import { useViewPort } from "@website/hooks/viewport";
import { LazyImage } from "@website/ui/lazy-image";
import { starsHotelImage } from "@website/ui/stars-hotel-image";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCardCarousel: FC<TourCardCarouselPropertiesType> = properties => {
  const $ = _c(17);
  const {
    thumbnails,
    badges,
    id,
    stars
  } = properties;
  let t0;
  if ($[0] !== thumbnails) {
    t0 = {
      thumbnails
    };
    $[0] = thumbnails;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    carousel,
    handleChangeImage
  } = useTourCardCarousel(t0);
  const router = useRouter();
  const {
    isDesktop
  } = useViewPort();
  let t1;
  if ($[2] !== id || $[3] !== isDesktop || $[4] !== router) {
    t1 = () => {
      if (id) {
        router?.[isDesktop ? "replace" : "push"]({
          pathname: router.pathname,
          query: {
            ...router.query,
            [HOTEL_DETAILS_MODAL]: id,
            [HOTEL_DETAILS_ACTIVE_TAB]: "gallery"
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }
    };
    $[2] = id;
    $[3] = isDesktop;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const openDrawer = t1;
  let t2;
  if ($[6] !== carousel || $[7] !== handleChangeImage || $[8] !== openDrawer || $[9] !== stars || $[10] !== thumbnails) {
    t2 = Array.isArray(thumbnails) && thumbnails?.map((item, index) => <button className={`shrink-0 snap-start scroll-mx-1 md:aspect-[4/3] ${carousel.currentIndex === index ? "md:block" : "md:hidden"} ${thumbnails.length === 1 ? "max-md:w-full" : ""}`} key={item.src} onClick={openDrawer} type="button"><LazyImage alt={item.title} className={`h-[7.5rem] md:h-full md:w-[19rem] ${thumbnails.length === 1 ? "max-md:w-full" : ""}`} fallback={starsHotelImage(stars || 0).src} loading="lazy" src={item?.src} />{thumbnails.length > 1 && <><TourCardCarouselPagination {...carousel} /><TourCardCarouselNavigation onChange={handleChangeImage} /></>}</button>);
    $[6] = carousel;
    $[7] = handleChangeImage;
    $[8] = openDrawer;
    $[9] = stars;
    $[10] = thumbnails;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== badges) {
    t3 = Array.isArray(badges) && <TourCardCarouselBadges badges={badges} />;
    $[12] = badges;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <div className="relative flex w-full snap-x snap-mandatory gap-1 max-md:overflow-x-auto md:w-[19rem]">{t2}{t3}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};